import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c8b9310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-autocomplete" }
const _hoisted_2 = { class: "header-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_input = _resolveComponent("joy-input")!
  const _component_joy_highlight = _resolveComponent("joy-highlight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_joy_input, {
        ref: "inputLocation",
        invalid: !_ctx.isValid,
        autocomplete: "off",
        icon: "location",
        placeholder: _ctx.$msg('profile.creation.completion.wizard.details.location.placeholder'),
        onFocusCapture: _ctx.emitFocus
      }, null, 8, ["invalid", "placeholder", "onFocusCapture"])
    ]),
    (_ctx.isBlockedCountry)
      ? (_openBlock(), _createBlock(_component_joy_highlight, {
          key: 0,
          level: "info",
          "display-icon": "",
          accent: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$msg('profile.location.blocked.country.highlight.warning', this.address.country)), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$msg('profile.location.blocked.country.highlight.description.1', this.address.country)) + " " + _toDisplayString(_ctx.$msg('profile.location.blocked.country.highlight.description.2')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}